.inputWrapper {
	position: relative;
}

.icon {
	position: absolute;
	top: 36px;
	right: 12px;
	width: 8px;
	height: 5px;
	line-height: 1.5;
	color: var(--content-tertiary);
	text-transform: uppercase;
	composes: body-2 bold from global;
	pointer-events: none;
	user-select: none;
	transition: 0.3s;
}

.clearButton {
	position: absolute;
	top: 31px;
	right: 12px;
	width: 14px;
	height: 14px;
	line-height: 1.5;
	color: var(--content-tertiary);
	text-transform: uppercase;
	composes: body-2 bold from global;
}

.clearButton svg {
	height: 14px;
	width: 14px;
}

.iconOpen {
	rotate: 180deg;
}

.popoverRoot:focus-visible {
	outline: none;
}

.popoverRoot:focus-visible [data-popover-container="true"] {
	outline: var(--focus-outline);
}

.popover {
	width: var(--trigger-width);
	margin-top: -24px;
	background-color: var(--elevation-default);
	border: solid 1px var(--border-primary);
	border-radius: 8px;
	height: fit-content;
	box-shadow: var(--box-shadow);
	overflow: hidden;
	outline: none;
	max-height: 260px;
	display: flex;
	flex-direction: column;
}
